import * as React from 'react';
import { useEffect } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useHistory, useLocation } from 'react-router-dom';

import { useConfig } from '../../../../context';
import { mapRoutePath } from '../lib/mapRoutePath';

export const AlternativeRoutingRedirector: React.FC = () => {
	const enabled = useConfig().global.alternativeRouting ?? false;
	const history = useHistory();
	const location = useLocation();

	useEffect(() => {
		if (!enabled) {
			return;
		}

		const alt = mapRoutePath(location.pathname, true);

		if (alt !== location.pathname) {
			history.replace({ ...location, pathname: alt });
		}
	}, [enabled, location.pathname]);

	return null;
};
